
define('text!core/controllers/ExternalRedirect.html',[],function () { return '<div data-ng-controller="ExternalRedirectController">\n</div>';});

